import escapeRegExp from '../../../utils/escapeRegExp';

var regExpCache = {};

export default function ( haystack, needles ) {
	return haystack.search( regExpCache[needles.join()] || ( regExpCache[needles.join()] = new RegExp( needles.map( escapeRegExp ).join( '|' ) ) ) );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/parse/converters/utils/getLowestIndex.js.map
